import React, { Component, Fragment } from 'react';
import { List, Button, Divider, Spin, Avatar } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import moment from 'moment';

class ListNotification extends Component {  

    render() {
        const { notifications, pagination, handleClickNotification, handleClickMore, isLoading } = this.props;
        return (
            <Fragment>
                {(isLoading) &&
					<div className="loading-container loading-absolute loading-100">
						<Spin size="large" tip="Cargando" />
					</div>
				}
                
                <List
                    itemLayout="horizontal"
                    dataSource={notifications}
                    renderItem={item => (                        
                    <List.Item onClick={handleClickNotification.bind(this, item)}>
                        <div 
                            className={(item.seen ? 'seen' : 'unseen')}
                            >
                            <List.Item.Meta
                                avatar = {<Avatar  style={{ color: '#FFC400', backgroundColor: 'transparent' }} icon={<WarningOutlined/>} />}
                                title = {item.title}
                                description = {moment(new Date(item.createdDate)).format("DD-MM-YYYY HH:mm:ss")}
                            />
                        </div>
                    </List.Item>
                    )}
                /> 
                
                {
                    pagination.totalCount > pagination.pageCount && 
                    <div>
                        <Divider className='divider' />
                        <Button 
                            className='btn-more-notifications' 
                            type="link" onClick={handleClickMore} 
                            >
                                más
                        </Button>
                    </div>
                }                
                
            </Fragment>
        );
    }
}

export default ListNotification;
